export default "__VITE_PUBLIC_ASSET__f87de60e__"